import {
  useEffect,
  useSharableStates,
  view,
  WritableObservableValue,
} from '@esui/core';
import { html } from 'lit';
import { DemoPage, VSection } from '../@demo/utils.js';
import { Tab } from './tab.js';
import { TabBar } from './tabbar.js';

export const [TabDemo] = view('esui-tab-demo', {
  Props: class {},
  template() {
    const [
      basicIndex,
      fadingIndicatorIndex,
      minWidthIndex,
      minWidthIndicatorIndex,
      minWidthAndMinIndicatorIndex,
      withIconsIndex,
      onlyIconIndex,
    ] = useSharableStates(
      0,
      0,
      0,
      0,
      0,
      0
    ) as WritableObservableValue<number>[];

    return DemoPage(
      VSection(
        'Basic',
        TabBar(Tab('One'), Tab('Two'), Tab('Three')).activeIndex(basicIndex)
      ),
      VSection(
        'Fading indicator',
        TabBar(
          Tab('One').isFadingIndicator(),
          Tab('Two').isFadingIndicator(),
          Tab('Three').isFadingIndicator()
        ).activeIndex(fadingIndicatorIndex)
      ),
      VSection(
        'Min Width Tab',
        TabBar(
          Tab('One').minWidth(),
          Tab('Two').minWidth(),
          Tab('Three').minWidth()
        ).activeIndex(minWidthIndex)
      ),
      VSection(
        'Min Width Indicator',
        TabBar(
          Tab('One').isMinWidthIndicator(),
          Tab('Two').isMinWidthIndicator(),
          Tab('Three').isMinWidthIndicator()
        ).activeIndex(minWidthIndicatorIndex)
      ),
      VSection(
        'Min Width Tab - Min Width Indicator',
        TabBar(
          Tab('One').minWidth().isMinWidthIndicator(),
          Tab('Two').minWidth().isMinWidthIndicator(),
          Tab('Three').minWidth().isMinWidthIndicator()
        ).activeIndex(minWidthAndMinIndicatorIndex)
      ),
      VSection(
        'With Icons',
        TabBar(
          Tab('One').icon('accessibility'),
          Tab('Two').icon('exit_to_app'),
          Tab('Three').icon('camera')
        ).activeIndex(withIconsIndex)
      ),
      VSection(
        'Only Icons',
        TabBar(
          Tab().icon('accessibility'),
          Tab().icon('exit_to_app'),
          Tab().icon('camera')
        ).activeIndex(onlyIconIndex)
      ),
      VSection(
        'Image Icons',
        TabBar(
          Tab().hasImageIcon().imageIcon(html`
            <svg slot="icon" width="10px" height="10px">
              <circle r="5px" cx="5px" cy="5px" color="red"></circle>
            </svg>
          `),
          Tab().hasImageIcon().imageIcon(html`
            <svg slot="icon" width="10px" height="10px">
              <rect width="10px" height="10px" color="green"></rect>
            </svg>
          `),
          Tab().hasImageIcon().imageIcon(html`
            <svg slot="icon" width="14.143px" height="14.143px">
              <rect
                width="10px"
                height="10px"
                color="blue"
                y="2.071px"
                x="2.071px"
                style="transform:rotate(45deg);transform-origin:center;"
              ></rect>
            </svg>
          `)
        ).activeIndex(onlyIconIndex)
      )
    );
  },
});
